export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15166.ea0014b6.jpg";